import { ZodType, z } from 'zod';

/**
 * Checks the runtime type of data passed to this function using a zod schema
 * @param {ZodType} schema Schema to check against
 * @param {unknown} data Data to check
 * @returns {z.infer<typeof schema>} Returns the checked and correctly typed data
 */

export const checkRuntimeType = (
  schema: ZodType,
  data: unknown
): z.infer<typeof schema> => {
  const result = schema.safeParse(data);

  if (!result.success) {
    throw new Error(
      `Runtime type validation failed with the following validation error:\n${result.error}`
    );
  }

  return result.data;
};
